import { COMMON_AXISLABEL_FORMATTER } from './base';
export var SHOP_THEME = {
  // 主题色
  SHOP_COLOR: ['#2BB3EDFF', '#34D19DFF', '#FFCC4AFF', '#FF7356FF'],
  // 图例
  SHOP_LEGEND: {
    type: 'plain',
    icon: 'rect',
    left: 10,
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 20,
    padding: 10,
    itemStyle: {
      opacity: 1
    },
    textStyle: {
      color: 'rgba(0, 0, 0, 0.9)',
      fontSize: 12,
      lineHeight: 18,
      padding: [0, 0, 0, 5],
      fontFamily: 'Microsoft YaHei'
    },
    backgroundColor: 'rgba(0,0,0,0.02)'
  },
  // tooltip
  SHOP_TOOLTIP: {
    show: true,
    confine: true,
    trigger: 'axis',
    borderRadius: 2,
    backgroundColor: 'rgba(255,255,255,0.9)',
    extraCssText: 'box-shadow: 0px 0px; border: 1px solid rgba(232,232,232,1);',
    textStyle: {
      color: 'rgba(0,0,0,0.85)'
    }
  },
  // 轴线样式
  SHOP_AXISLINE: {
    show: true,
    lineStyle: {
      type: 'solid',
      color: '#D9D9D9FF'
    }
  },
  // 轴文本样式
  SHOP_AXISLABEL: {
    show: true,
    margin: 12,
    color: '#00000073',
    formatter: COMMON_AXISLABEL_FORMATTER
  },
  // 参考线样式
  SHOP_SPLITLINE: {
    lineStyle: {
      type: 'solid',
      color: '#E8E8E8FF'
    }
  },
  // 指示线样式
  SHOP_AXISPOINTER: {
    type: 'line',
    lineStyle: {
      type: 'solid',
      color: '#000000D9'
    },
    z: 0
  }
};